var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbar tabbar-fixed"},[_vm._t("default"),_c('price-detail',{ref:"priceDetail",attrs:{"price-list":_vm.priceList}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }